<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', segmento)">
      <v-card v-if="segmento" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Segmento </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="segmento.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="segmento.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(segmento)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Segmento from '../../models/segmento'
import SegmentoService from '../../services/segmento/segmento'
import { obrigatorio } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'segmentoParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    segmento: new Segmento(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    segmentoParam() {
      return this.segmentoParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.segmento = new Segmento()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.segmento = this.segmentoParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const segmentoSalva =
          this.operacao === 'adicionar'
            ? await SegmentoService.create({ ...data })
            : await SegmentoService.update(data.id, data)

        this.$emit('confirmado', segmentoSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
